import { useCircleSize, useTheme, useRadiusSize } from "arkh";
import styles from "./UrgentAnimation.module.css";
import React from "react";

export const UrgentAnimation = React.memo(PrioAnimationC);
function PrioAnimationC() {
  const size = useCircleSize("small");
  const theme = useTheme();
  const cr = useRadiusSize("small");

  return (
    <div
      style={{
        width: size,
        height: size,
        backgroundColor: theme.negative,
        animationName: styles.Pulse,
        borderRadius: cr,
      }}
      className={styles.PrioAnimation}
    />
  );
}
